(function () {
  var WEEK_MS = 7 * 24 * 60 * 60 * 1000;
  var timers = new WeakMap();
  var actionEventsBound = false;

  function getShopifyRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/').replace(/\/?$/, '/');
  }

  function navigateToProduct(element, attribute) {
    var url = element.getAttribute(attribute);
    if (url) window.location.assign(url);
  }

  function refreshCartSidebar() {
    if (window.Shopify && typeof window.Shopify.getCart === 'function' && typeof window.updateSidebarCart === 'function') {
      window.Shopify.getCart(function (cartTotal) {
        document.body.classList.add('cart-sidebar-show');
        window.updateSidebarCart(cartTotal);
      });
      return;
    }

    window.location.assign(getShopifyRoot() + 'cart');
  }

  async function addVariantToCart(element) {
    if (element.getAttribute('aria-busy') === 'true') return;

    var variantId = element.getAttribute('data-variant-id');
    if (!variantId) return;

    element.classList.add('is-loading');
    element.setAttribute('aria-busy', 'true');

    try {
      var response = await fetch(getShopifyRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });

      if (!response.ok) {
        var errorData = await response.json().catch(function () { return {}; });
        throw new Error(errorData.description || errorData.message || 'Unable to add this item to cart.');
      }

      refreshCartSidebar();
    } catch (error) {
      if (typeof window.showWarning === 'function') {
        window.showWarning(error.message);
      } else {
        console.error(error);
      }
    } finally {
      element.classList.remove('is-loading');
      element.removeAttribute('aria-busy');
    }
  }

  function bindPromoActions() {
    if (actionEventsBound) return;
    actionEventsBound = true;

    document.addEventListener('click', function (event) {
      var productImage = event.target.closest('[data-prod-href]');
      if (productImage) {
        navigateToProduct(productImage, 'data-prod-href');
        return;
      }

      var shopAction = event.target.closest('[data-blast-bounty-shop]');
      if (shopAction) {
        navigateToProduct(shopAction, 'data-url');
        return;
      }

      var addAction = event.target.closest('[data-blast-bounty-add]');
      if (addAction) addVariantToCart(addAction);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var action = event.target.closest('[data-prod-href], [data-blast-bounty-shop], [data-blast-bounty-add]');
      if (!action || event.target.closest('[aria-disabled="true"]')) return;
      event.preventDefault();
      if (action.hasAttribute('data-prod-href')) {
        navigateToProduct(action, 'data-prod-href');
      } else if (action.hasAttribute('data-blast-bounty-shop')) {
        navigateToProduct(action, 'data-url');
      } else {
        addVariantToCart(action);
      }
    });
  }

  function updateCountdown(element) {
    var now = Date.now();
    var startTime = Date.parse(element.getAttribute('data-start-time'));
    var endTime = Date.parse(element.getAttribute('data-end-time'));
    var timerDisplay = element.querySelector('.blast-bounty-promo__timer');

    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || endTime <= startTime || !timerDisplay) {
      if (timerDisplay) timerDisplay.hidden = true;
      return false;
    }

    if (now < startTime) {
      timerDisplay.hidden = true;
      return true;
    }

    timerDisplay.hidden = false;
    if (now >= endTime) {
      ['days', 'hours', 'minutes', 'seconds'].forEach(function (unit) {
        var valueElement = element.querySelector('[data-countdown-value="' + unit + '"]');
        if (valueElement) valueElement.textContent = '00';
      });
      return false;
    }

    var elapsedSinceStart = now - startTime;
    var elapsedInCycle = elapsedSinceStart % WEEK_MS;
    var remainingInCycle = WEEK_MS - elapsedInCycle;
    var remainingToEnd = endTime - now;
    var secondsLeft = Math.max(0, Math.floor(Math.min(remainingInCycle, remainingToEnd) / 1000));
    var values = {
      days: Math.floor(secondsLeft / 86400),
      hours: Math.floor((secondsLeft % 86400) / 3600),
      minutes: Math.floor((secondsLeft % 3600) / 60),
      seconds: secondsLeft % 60,
    };

    Object.keys(values).forEach(function (unit) {
      var valueElement = element.querySelector('[data-countdown-value="' + unit + '"]');
      if (valueElement) valueElement.textContent = String(values[unit]).padStart(2, '0');
    });

    return true;
  }

  function initCountdown(element) {
    if (timers.has(element)) window.clearInterval(timers.get(element));
    if (!updateCountdown(element)) return;
    var timer = window.setInterval(function () {
      if (!updateCountdown(element)) {
        window.clearInterval(timer);
        timers.delete(element);
      }
    }, 1000);
    timers.set(element, timer);
  }

  function initWithin(root) {
    if (!root) return;
    bindPromoActions();
    if (root.matches && root.matches('[data-blast-bounty-countdown]')) initCountdown(root);
    root.querySelectorAll('[data-blast-bounty-countdown]').forEach(initCountdown);
  }

  initWithin(document);

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target;
    if (root.matches && root.matches('[data-blast-bounty-countdown]') && timers.has(root)) {
      window.clearInterval(timers.get(root));
      timers.delete(root);
    }
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-blast-bounty-countdown]').forEach(function (element) {
      if (timers.has(element)) {
        window.clearInterval(timers.get(element));
        timers.delete(element);
      }
    });
  });
})();
